module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x10-45932bdab9bb3c4f0a52381c5fcaa79b.png";